import { Navigate } from 'react-router-dom'
import { useEmployerOrganisationOptional } from '@/context/employer-organisation-context'
import { resolveUpgradePlanPath } from '@/constants/upgrade-plan'

/** Legacy `/settings/billing` → org-scoped billing settings. */
export function SettingsBillingRedirect() {
  const employerOrg = useEmployerOrganisationOptional()
  const target = resolveUpgradePlanPath(employerOrg?.activeOrganisationSlug)
  return <Navigate to={target} replace />
}
